import { Button, ButtonProps } from "@mui/material";
import React, { FC } from "react";
import { ToolTip } from "../Tooltip/ToolTip";
import "./styles.css";

type PrimaryButtonProps = Pick<ButtonProps, 'startIcon' | 'endIcon'> & {
  onClick: (e?: any) => void;
  disabled?: boolean;
  children: React.ReactNode | string;
  variant?: any;
  className?: string;
  fullWidth?: boolean;
  title?: string;
  sx?: Object;
  type?: any;
  tooltipInfo?: string;
};

const PrimaryButton: FC<PrimaryButtonProps> = ({
  onClick,
  disabled,
  variant = "contained",
  fullWidth = true,
  className,
  children,
  title,
  type,
  sx,
  tooltipInfo,
  startIcon,
  endIcon,
  ...rest
}) => {
  return (
    <ToolTip title={tooltipInfo}>
      <Button
        type={type}
        title={title}
        fullWidth={fullWidth}
        sx={sx}
        data-testid="primary-button"
        disabled={disabled}
        onClick={onClick}
        variant={variant}
        startIcon={startIcon}
        endIcon={endIcon}
        {...rest}
      >
        {children}
      </Button>
    </ToolTip>
  );
};
export default PrimaryButton;
